export default { 
    influencer (state) {
        return state.influencer
    }
}